module.exports = __webpack_public_path__ + "static/media/appointment_cancelled.96ec6d32.svg";